import { Box } from '@mui/material'
import { useCallback } from 'react'
import { useStyles } from './styles'

interface IKanbanStatus {
  status: 'toDo' | 'initialized' | 'completed'
  stage: string
  counter: string | number
}

const KanbanStatus = ({ status, counter, stage }: IKanbanStatus) => {
  const classes = useStyles()

  const changeStyleByStatus = useCallback(
    (status: IKanbanStatus['status']) => {
      switch (status) {
        case 'toDo':
          return classes.containerToDo
        case 'initialized':
          return classes.containerInitialized
        case 'completed':
          return classes.containerCompleted
        default:
          break
      }
    },
    [status]
  )

  return (
    <Box className={changeStyleByStatus(status)}>
      <Box className={classes.textContainer}>
        <span>{stage}</span>
      </Box>
      <Box className={classes.statusCounter}>
        <span>{counter}</span>
      </Box>
    </Box>
  )
}

export default KanbanStatus
